import { useMemo, useState } from 'react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import MainPageSliderCard from './components/MainPageSliderCard';
import { useGetSinglePage } from 'react-easyrocket';
import { NewCarousel } from 'src/components/Carousels/NewCarousel';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import { Skeletons } from 'src/components/Skeletons';
import { useHideSlidesByGeo } from './hooks/useHideSlidesByGeo';

export const MainPageBannersMobile = () => {
  const { childs = [], isFetched, isFetching } = useGetSinglePage('main_sliders');
  const [showSliderControls, setShowSliderControls] = useState<boolean>(false);
  const geoFilter = useHideSlidesByGeo();

  const isSlideImage = () => {
    return childs.filter((child) => Boolean(child.imageMobile));
  };

  const mainPageSlides = useMemo(() => {
    return geoFilter(childs).map((child) => <MainPageSliderCard key={child.code} slide={child} />);
  }, [childs, geoFilter]);

  return (
    <>
      {isFetching ? (
        <Skeletons className="aspect-[360/267] md:aspect-[1200/487] w-[100vw] 768:w-full mb-[10px]" />
      ) : (
        <div
          className="w-full"
          onMouseEnter={() => setShowSliderControls(true)}
          onMouseLeave={() => setShowSliderControls(false)}>
          {isFetched && childs && childs?.length > 0 && isSlideImage()?.length && (
            <NewCarousel
              slides={mainPageSlides}
              navigation={childs && childs?.length >= 3 && showSliderControls}
              modules={[Navigation, Pagination, Autoplay]}
              className="min-w-full custom-swiper-controls"
              classNameForSlide="flex justify-center items-center"
              rewind={true}
              pagination={{
                clickable: true
              }}
              centeredSlidesBounds
              autoplay={{
                delay: 7000,
                disableOnInteraction: true
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  initialSlide: 0,
                  spaceBetween: 5
                },
                768: {
                  slidesPerView: 1,
                  initialSlide: 0,
                  spaceBetween: 10
                },
                1024: {
                  slidesPerView: 1,
                  initialSlide: 1,
                  spaceBetween: 20
                },
                1200: {
                  slidesPerView: 1,
                  initialSlide: 1,
                  spaceBetween: 20
                }
              }}
            />
          )}
          {!isFetched && (
            <div className="w-full aspect-[360/267] md:aspect-[1200/487] mb-[34px]"></div>
          )}
        </div>
      )}
    </>
  );
};
